<template>
<span>
    <shabake-details></shabake-details>
    <page-footer></page-footer>
</span>
</template>
<script>
import ShabakeDetails from '@/components/moduls/ShabakeDetails';
import PageFooter from '@/components/PageFooter';
export default {
    name :'shabake',
    components:{
        ShabakeDetails,
        PageFooter
    }

    
};
</script>


